import { LogDtoToLog, LogsDtoToLogs } from '../../mappers/logs';
import { api } from './api';
export const LogsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getLogs: builder.query({
            query: params => ({
                method: 'get',
                url: `/api/LogPDC?${params.filter}`,
                params: {
                    items: params.quantity || 5,
                    pagina: params.page || 1,
                    dataInicio: params.startDate,
                    dataFim: params.endDate,
                    nomeUsuario: params.term || null,
                },
            }),
            transformResponse: (dto) => LogsDtoToLogs(dto),
        }),
        getScheduleLogs: builder.query({
            query: id => ({
                method: 'get',
                url: `/api/AgendamentoLogPDC/GetById/${id}`,
            }),
            transformResponse: (dto) => LogDtoToLog(dto, 'schedule'),
        }),
        getFaqLogs: builder.query({
            query: id => ({
                method: 'get',
                url: `/api/FAQLogPDC/GetById/${id}`,
            }),
            transformResponse: (dto) => LogDtoToLog(dto, 'faq'),
        }),
        getFinancialLogs: builder.query({
            query: id => ({
                method: 'get',
                url: `api/FaturamentoLogPDC/GetById/${id}`,
            }),
            transformResponse: (dto) => LogDtoToLog(dto, 'financial'),
        }),
        getCRLVLog: builder.query({
            query: id => ({
                method: 'get',
                url: `api/CRLVLogpdc/GetById/${id}`,
            }),
            transformResponse: (dto) => LogDtoToLog(dto, 'CRLV'),
        }),
    }),
});
export const { useLazyGetLogsQuery, useLazyGetFaqLogsQuery, useLazyGetFinancialLogsQuery, useLazyGetScheduleLogsQuery, useLazyGetCRLVLogQuery, } = LogsApi;
